
const DownArrowIconLarge = ({ className = "" }) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M9.99999 10.9773L14.125 6.85232L15.3033 8.03065L9.99999 13.334L4.69666 8.03065L5.87499 6.85232L9.99999 10.9773Z" fill="#667085" />
        </svg>
    )
}

export default DownArrowIconLarge